import { Flex } from '@repo/ui/Flex';
import { Icon } from '@repo/ui/Icon';
import { Text } from '../Language/Language';
import { Button } from '@repo/ui/Button';
import s from './SubSections.module.css';
import { Collapsible } from '@repo/ui/Collapsible';
import { CollapsibleHeader } from '../CollapsibleHeader/CollapsibleHeader';

export const GiftSubSection = ({ onChange }: { onChange: () => void }) => (
  <Collapsible
    collapsed={true}
    header={
      <CollapsibleHeader
        id="giftReturnSubSectionHeader"
        language={{ langKey: 'pdx.auth.subsection.gift.title' }}
      />
    }
  >
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="g-48"
      padding="p-40"
    >
      <Icon name="gift" className={s.icon} />
      <div className={s.description}>
        <Text langKey="pdx.auth.subsection.gift.description" />
      </div>
      <Button onClick={onChange} variant="secondary">
        <Text langKey="pdx.auth.subsection.gift.button" />
      </Button>
    </Flex>
  </Collapsible>
);
